import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import { useTranslation } from 'react-i18next';

function FileIcon({ color = 'currentColor', className }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            fill="none"
            viewBox="0 0 20 20"
            className={className}
        >
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M12 1.5H4.8A1.8 1.8 0 0 0 3 3.3v13.4a1.8 1.8 0 0 0 1.8 1.8h10.8a1.8 1.8 0 0 0 1.8-1.8V6.9z"
                clipRule="evenodd"
            />
        </svg>
    );
}

FileIcon.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

export default function InvoiceQuickEditorDrawerPreviewEmpty(props) {
    const { className, compactMode } = props;

    const { t } = useTranslation('invoices');

    return (
        <div className={cn('bg-neutral-100 flex items-center justify-center h-full p-4', className)}>
            <label
                className={cn(
                    'relative bg-white rounded-lg md:rounded-2xl w-full max-w-[304px] mx-auto border-gray-300 py-14 px-16 flex-grow',
                    compactMode && 'max-w-[186px] px-6 py-5',
                )}
            >
                <div className={cn('text-center text-gray-500')}>
                    <div className="mb-1.5 md:mb-3 flex justify-center">
                        <FileIcon className="size-6 md:size-9 text-gray-200" />
                    </div>
                    <div className="font-semibold text-xs md:text-base text-pretty">
                        {t('no-file-associated-with-the-invoice')}
                    </div>
                </div>
            </label>
        </div>
    );
}

InvoiceQuickEditorDrawerPreviewEmpty.propTypes = {
    className: PropTypes.string,
    compactMode: PropTypes.bool,
};
